document.documentElement.classList.add('cm-js');
document.addEventListener('DOMContentLoaded', () => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const elements = document.querySelectorAll('.cm-reveal');
  if (reducedMotion || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    elements.forEach((element) => observer.observe(element));
  }

  const productRequests = new WeakMap();
  const bindProduct = (root) => {
    const form = root.querySelector('.cm-buy-form');
    if (!form) return;
    const controls = form.querySelectorAll('[data-cm-option-position] input, [data-cm-option-position] select');
    const changeSelection = async (event) => {
      const groups = [...form.querySelectorAll('[data-cm-option-position]')].sort((a, b) => Number(a.dataset.cmOptionPosition) - Number(b.dataset.cmOptionPosition));
      const selectedIds = groups.map((group) => group.querySelector('input:checked')?.value || group.querySelector('select')?.value);
      if (!groups.length || selectedIds.some((id) => !id)) return;

      productRequests.get(root)?.abort();
      const controller = new AbortController();
      productRequests.set(root, controller);
      const addButton = form.querySelector('[data-cm-add]');
      if (addButton) addButton.disabled = true;
      const variantInput = form.querySelector('[data-cm-variant-id]');
      if (variantInput) variantInput.value = '';

      const url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('option_values', selectedIds.join(','));
      const sectionUrl = new URL(url);
      sectionUrl.searchParams.set('section_id', root.dataset.cmSectionId);

      try {
        const response = await fetch(sectionUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Impossibile aggiornare la variante');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('[data-cm-product]');
        const nextDetails = next?.querySelector('.cm-product__details');
        const nextGallery = next?.querySelector('.cm-product__gallery');
        if (!nextDetails || !nextGallery) throw new Error('Scheda prodotto incompleta');
        if (productRequests.get(root) !== controller) return;

        const changedPosition = event.target.closest('[data-cm-option-position]')?.dataset.cmOptionPosition;
        const changedValue = event.target.value;
        root.querySelector('.cm-product__details')?.replaceWith(nextDetails);
        root.querySelector('.cm-product__gallery')?.replaceWith(nextGallery);
        window.history.replaceState({}, '', url);
        bindProduct(root);
        const changedGroup = [...root.querySelectorAll('[data-cm-option-position]')].find((group) => group.dataset.cmOptionPosition === changedPosition);
        const focusTarget = [...(changedGroup?.querySelectorAll('input, select') || [])].find((control) => control.value === changedValue);
        focusTarget?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(url);
      }
    };
    controls.forEach((control) => control.addEventListener('change', changeSelection));
  };
  document.querySelectorAll('[data-cm-product]').forEach(bindProduct);

  document.querySelectorAll('.cm-mobile-menu').forEach((details) => {
    details.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { details.open = false; }));
  });
});
